import { render, staticRenderFns } from "./FieldPalette.vue?vue&type=template&id=875a4066&scoped=true&"
import script from "./FieldPalette.vue?vue&type=script&lang=js&"
export * from "./FieldPalette.vue?vue&type=script&lang=js&"
import style0 from "./FieldPalette.vue?vue&type=style&index=0&id=875a4066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875a4066",
  null
  
)

export default component.exports